class ProductDescription extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelectorAll(".button--primary");
    this.moreInfo = this.querySelector(".description_cta_wrapper.wrapper_more");
    this.lessInfo = this.querySelector(".description_cta_wrapper.wrapper_less");

    this.button.forEach((btn) => {
      btn.addEventListener("click", this.handleOpen.bind(this));
    });

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        this.calculateHeight();
      }, 1000);
    });
  }

  calculateHeight() {
    const isMobile = window.matchMedia("(max-width: 768px)");
    const productBundle = document.querySelector(".product-page--bundle");

    if (isMobile.matches || !productBundle) {
      this.style.maxHeight = "70vh";
    } else {
      const infoHeight = document.querySelector(
        ".product-container .product-column-form"
      ).offsetHeight;
      const galleryHeight =
        document.querySelector(".product-column-gallery").offsetHeight;
      const descriptionHeight = infoHeight - galleryHeight;

      this.style.maxHeight = `${descriptionHeight}px`;
    }
  }

  handleOpen() {
    this.classList.toggle("open");

    if (this.classList.contains("open")) {
      this.moreInfo.classList.remove("active");
      this.lessInfo.classList.add("active");
      return;
    }

    this.scrollIntoView({ block: "start", behavior: "smooth" });
    this.moreInfo.classList.add("active");
    this.lessInfo.classList.remove("active");
  }
}

customElements.define("product-description", ProductDescription);
